// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__27OC-","inputWrap":"CustomTip_inputWrap__3apcy"};